import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface LibraryTab {
  id: string;
  label: string;
}

interface LibraryStat {
  label: string;
  value: string;
}

interface LibraryCollectionItem {
  sno: number;
  department: string;
  titles: number;
  volumes: number;
  national: string;
  international: string;
  eResources: string;
}

@Component({
  selector: 'app-cart-page',
  templateUrl: './cart-page.component.html',
  styleUrls: ['./cart-page.component.scss']
})
export class CartPageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  pageTitle = 'Central Library';
  pageSubtitle =
    'A peaceful, resource-rich, and technology-enabled learning space that supports academic excellence, research, reading culture, and lifelong learning.';

  admissionNotice =
    'Admissions open for 2026 : B.E (CIVIL), B.E (CSE), B.E (CSE - AI & ML), B.E (CSE - CS), B.E (ECE), B.E (EEE), B.E (MECH), MBA, M.E (CSE), M.E (Embedded System Technologies), M.E (Thermal Engineering).';

  tabs: LibraryTab[] = [
    { id: 'tab1', label: 'About the Library' },
    { id: 'tab2', label: 'Library Pictography' },
    { id: 'tab3', label: 'Sections & Resources' },
    { id: 'tab4', label: 'Book Policy' },
    { id: 'tab5', label: 'Facilities' },
    { id: 'tab6', label: 'Rules & Regulations' },
    { id: 'tab7', label: 'Future Plans' },
    { id: 'tab8', label: 'Features' }
  ];

  heroStats: LibraryStat[] = [
    { label: 'Area', value: '454 Sq. Meter' },
    { label: 'Seating', value: '110 Students' },
    { label: 'Volumes', value: '19,895+' },
    { label: 'E-Books', value: '9,786+' }
  ];

  aboutParagraphs: string[] = [
    'Our Central Library is one of the major highlights of the college. It is a 454 square meter central library that has a seating capacity for 110 students. The excellent reading hall in the library ensures a peaceful and conducive environment that promotes a spirit of continuous learning among the students. It is well equipped with reference books, hand books, dictionaries and encyclopedias.',
    'The Library provides a wide range of books and periodicals to meet the diverse needs of the academic community by involving the faculty, students and the administration in the development and periodic assessment of the library services and resources. It also offers a peaceful environment for the optimum use of library materials and schedules service hours with professional assistance. It assists in computing resource plans and automation processes, provides physical facilities and required equipment.',
    'The library has 19895 numbers of volumes and 5735 numbers of titles, a separate periodicals section, and subscribes to 168 International and National periodicals. The library regularly receives journals and newsletters from various organizations and societies. It provides staff and students with the latest information in technical education, research and development activities.',
    'The Central Library is equipped with 15 computer terminals with online access facilities through DELNET. It provides access to more than 3650+ National and International E-Journals. The library also has a continuously expanding collection of over 9786 E-Books covering various fields such as Engineering, Management, Basic Science and Humanities. Every effort has been made to procure all titles recommended by the faculty.'
  ];

  aboutHighlights: string[] = [
    'Peaceful central reading hall with seating capacity for 110 students.',
    'Rich collection of books, reference materials, dictionaries, hand books, encyclopedias, and project reports.',
    'Separate periodicals section with 168 International and National journals and magazines.',
    '15 computer terminals with DELNET-based online access facilities.',
    'Access to 3650+ E-Journals and 9786+ E-Books in Engineering, Management, Basic Science, and Humanities.',
    'Professional support for automation, planning, access, and optimum utilization of learning resources.'
  ];

  libraryCollection: LibraryCollectionItem[] = [
    {
      sno: 1,
      department: 'Computer Science & Engineering (CSE, AIDS, AIML & Cyber Security)',
      titles: 837,
      volumes: 3897,
      national: '24',
      international: '24',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 2,
      department: 'Electronics & Communication Engineering',
      titles: 597,
      volumes: 2189,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 3,
      department: 'Electrical & Electronics Engineering',
      titles: 468,
      volumes: 1628,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 4,
      department: 'Mechanical Engineering',
      titles: 740,
      volumes: 2457,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 5,
      department: 'Automobile Engineering',
      titles: 412,
      volumes: 1465,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 6,
      department: 'Civil Engineering',
      titles: 612,
      volumes: 1898,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 7,
      department: 'M.E. - CSE',
      titles: 495,
      volumes: 927,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 8,
      department: 'M.E. – Thermal Engineering',
      titles: 255,
      volumes: 746,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 9,
      department: 'M.E. – Embedded System',
      titles: 216,
      volumes: 794,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 10,
      department: 'M.E. – Environmental Engineering',
      titles: 67,
      volumes: 237,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 11,
      department: 'MBA',
      titles: 212,
      volumes: 1310,
      national: '6',
      international: '6',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 12,
      department: 'Science & Humanities',
      titles: 685,
      volumes: 1795,
      national: '-',
      international: '-',
      eResources: 'DELNET and NDLI'
    },
    {
      sno: 13,
      department: 'General',
      titles: 319,
      volumes: 534,
      national: '-',
      international: '-',
      eResources: 'DELNET and NDLI'
    }
  ];

  periodicalsParagraphs: string[] = [
    'The library has a separate periodicals section and subscribes to 168 journals and magazines, including both International and National periodicals.',
    'The library regularly receives journals and newsletters from various organizations and societies and provides the staff and students with the latest information in technical education, research, and development activities.'
  ];

  referenceSectionParagraphs: string[] = [
    'The reference section of the library has a rich collection of International editions of reference books, hand books, conference proceedings, and encyclopedias.',
    'It also includes books for competitive examinations such as GATE, IELTS, GMAT, Civil Service Examinations, Bank Exams, Income Tax Exams, Railway Exams, LIC, TNPSC Examinations, and other entrance examinations.'
  ];

  backVolumesParagraphs: string[] = [
    'This library has a separate Back Volumes Section. We have a large collection of 794 back volumes.',
    'Back volumes of journals have been neatly bound and arranged subject wise and year wise for reference.'
  ];

  projectReportsParagraphs: string[] = [
    'This library has a separate Project Report section. It receives 785 project reports from our departments.',
    'They have been neatly bound and arranged subject wise and year wise for future reference. Newspapers, weekly and fortnightly magazines of repute are also subscribed to enable the students to keep abreast of day-to-day trends. The library comprises an Audio-Visual section equipped with LCD TV.'
  ];

  digitalMediaParagraphs: string[] = [
    'The library has a separate Digital Media section with 989 non-book materials.',
    'This library receives subscribed books on CD/DVD, engineering subject CD/DVD, GATE/GMAT/TOEFL materials, and other magazine CD/DVD resources. These are regularly provided to staff and students for the latest information in technical education, research, and development activities.'
  ];

  bookIssuePolicyParagraphs: string[] = [
    'All students, faculty, administrative staff and supporting staff of the college are entitled to become members of the central library. The membership application forms can be obtained from the circulation counter and should be submitted through proper channel.',
    'Each student is given 5 library cards and each staff member is given 10 cards. Books are lent to students for 15 days and to staff for one month, and they can be renewed for another 15 days. A fine is levied for late return of books.'
  ];

  bookBankSchemeParagraphs: string[] = [
    'As per the directions of Government of Tamil Nadu, the library has a book bank scheme exclusively for the SC/ST students.',
    'The students can avail of four additional books per semester apart from their regular library cards.'
  ];

  bookLostParagraphs: string[] = [
    'If books are lost, the borrower shall replace them with the same edition or the latest edition of the book, including the overdue fine, with permission from the librarian.'
  ];

  renewalParagraphs: string[] = [
    'I, II, and III year students are asked to renew their books by email during the study holidays only.',
    'If you want to renew your books, kindly send an email at least three days before the return date.'
  ];

  renewalDetails: string[] = [
    'Mail ID: libraryfmcet@gmail.com',
    'Required Information: Name',
    'Required Information: Roll Number',
    'Required Information: Access Number',
    'Required Information: Due Date'
  ];

  facilitiesItems: string[] = [
    'Security: Surveillance cameras are installed in the library.',
    'Reprography: Photocopying facility is available in the library. Nominal charge is collected. Photocopy = Rs. 1/- and Print = Rs. 1/- per page.',
    'Online Public Access Catalogue: The library is equipped with computerized On-line Public Access Catalogue (OPAC) for searching availability of books and CD-ROMs.',
    'Barcode system is followed in all transactions.'
  ];

  rules: string[] = [
    'The faculty, staff and students of Fatima Michael College of Engineering & Technology are the members of the library.',
    'The library is kept open on all days from 8.45 A.M to 6.00 P.M.',
    'The library user must produce their identity card when entering the library.',
    'Students are not allowed to carry anything inside the library. All personal belongings are to be left outside at the entrance of the library.',
    'Library tickets are issued only on production of identity cards, 10 tickets for faculty and 5 tickets for students.',
    'Each ticket is valid for only one book.',
    'The tickets issued are not transferable.',
    'The books should normally be returned on or before the due date positively.',
    'Fine is levied for late return of books.',
    'Books can be issued from the library to the members only in exchange for library borrower’s tickets.',
    'No user shall deface the library books by underlining, scribbling notes in the margins, etc.',
    'All users are requested to protect library books as their own property.',
    'Books taken from the shelves for reference should be left on the reading tables.',
    'Periodical publications, dictionaries, reports, proceedings, reference sources, etc. will not be lent out.',
    'All members and the library staff are requested to observe complete silence inside the library.'
  ];

  futurePlans: string[] = [
    'The Institute would become a fellow Corporate Member of the Library of ACM with full portal and online access to E-Books and video tutorials, enabling students and staff to refer to other members’ libraries for additional information for their research and projects.',
    'A new approach to circulation, tracking, inventorying, and the security of library materials using RFID technology is planned.'
  ];

  featureSections: { title: string; points: string[] }[] = [
    {
      title: 'Help-Desk',
      points: [
        'All members of the library team are available for any assistance you may need in using the library resources, facilities and services.',
        'For security purpose a video surveillance system is in use.',
        'You are also welcome to offer your suggestions regarding the same.'
      ]
    },
    {
      title: 'Book Searching Facility',
      points: [
        'The central library is maintaining library management software with a computerized On-line Public Access Catalogue (OPAC) for searching availability of books, National / International journals, periodicals and non-book materials (CD-ROMs).',
        'Renewal facilities are available.',
        'Barcode system is used for all transactions.'
      ]
    },
    {
      title: 'Question Papers',
      points: [
        'We provide previous year Anna University question papers which are maintained in a separate area.',
        'To access the question papers, present your student ID.',
        'We provide and maintain question papers organized year wise and department wise.'
      ]
    }
  ];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Central Library';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  ngOnInit(): void {}
}